<template>
  <EditForm :question="question" :editing="true"/>
</template>

<script>
import EditForm from '@/pages/admin/questions/practice/EditForm'
import PracticeQuestionService from '@/services/PracticeQuestionService'

export default {
  props: {
    id: String
  },
  data: () => ({
    question: PracticeQuestionService.getDefaultItem(),
    practiceQuestionService: undefined
  }),
  components: {EditForm},
  created () {
    this.practiceQuestionService = new PracticeQuestionService(this.$store)
    this.practiceQuestionService.getItem(this.id, (data) => {
      this.question = data.question
    })
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/questions/practice/Edit.vue